module.exports = __webpack_public_path__ + "img/Vimkey-macOS-store-setting.6cef7201.jpg";